<template>
  <!-- style="--main-color: initial" -->
  <div id="app" @scroll="handleScroll()">
    <!-- DEFINE HEADER -->
    <template v-if="this.$route.name !== 'Offline'">
      <Header :isScrolled="isScrolled" :isScrolledMobile="isScrolledMobile" v-if="this.$route.name !== 'App'"/>
    </template>
    <!-------------------->

    <main class="content-main" :class="{ 'content--offline': this.$route.name === 'Offline' }">
      <router-view />
    </main>

    <template v-if="this.$route.name !== 'Offline'">
      <!-- DEFINE MENU -->
      <Menu />
      <!-------------------->
  
      <!-- DEFINE FOOTER -->
      <Footer v-if="this.$route.name !== 'App'"/>
      <!-------------------->
      <!--- BACKDROP -->
      <div class="backdrop_bar" :class="{ 'd-none': !activeBackdrop }"></div>
      <div class="backdrop_bar-api" :class="{ 'd-none': !isLoadingApi }">
        <img src="@/assets/img/gif/loading.gif" alt="Loading GIF" width="50" height="50" />
      </div>
      <!-------------------->
    </template>
  </div>
</template>

<style lang="scss">

@import './assets/scss/generic/mixins.scss';
@import './assets/scss/generic/fonts.scss';
@import './assets/scss/generic/utilities.scss';

:root {
  --main-color: #C3100D;
  --main-color-light: #F21A35;
  --main-color2: #D9B48F;
  --main-color3: #C6AFA0;
  --main-color4: #5E4F47;
  --red: #CC0000;
  --red-2: #F21A35;
  --green: #00B373;
  --white: #fff;
  --black: #000;
  --gray: #B8B8B8;
  --gray-2: #BFBFBF;
}
html,
body {
  margin: 0;
  width: 100%;
  color: #687188;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow-x: hidden;
  background-color: #F9F9F9;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
@media (min-width: 992px){
  .container, .container-lg, .container-md, .container-sm {
    max-width: 1100px;
  }
}
@media (min-width: 1200px){
  .container, .container-lg, .container-md, .container-sm, .container-xl {
    max-width: 1180px;
  }
}
.swiper-button-next,
.swiper-button-prev {
  outline: none !important;
  &::after {
    content: none;
  }
}
.swiper-container .swiper-button-next,
.swiper-container .swiper-button-prev {
  background: 0;
  border: 0;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-hidden-api {
  overflow: hidden;
}
.backdrop_bar {
  position: fixed;
  z-index: 2;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(0,0,0,0.6);
}
.backdrop_bar-api {
  position: fixed;
  z-index: 2;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}
a {
  text-decoration: none !important;
}
button {
  outline: none !important;
}

input:focus, textarea:focus, select:focus{
  outline: none !important;
}
</style>
<script>
import Header from '@/components/headers/Header.vue';
import Menu from '@/components/menus/Menu.vue';
import Footer from '@/components/footers/Footer.vue';
import { mapGetters, mapMutations } from 'vuex';


export default {
  data() {
    return {
      isScrolled: false,
      isScrolledMobile: false
    }
  },
  components: {
    Header,
    Footer,
    Menu,
  },
  computed: {
    ...mapGetters(['isDesktop', "activeBackdrop", "isLoadingApi"])
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapMutations(['setIsDesktop',]),
    handleScroll(event) {
      if (event.currentTarget.innerWidth > 992) {
        if (event.currentTarget.scrollY > 100){
          this.isScrolled = true;
        } else {
          this.isScrolled = false;
        }
      } else {
        if (event.currentTarget.scrollY > 100){
          this.isScrolledMobile = true;
        } else {
          this.isScrolledMobile = false;
        }
      }
    }
  },
  mounted() {
    if (window.innerWidth > 992){
      this.setIsDesktop(true);
    } else {
      this.setIsDesktop(false);
    }
  },
}
</script>
